// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shyzx2M0_rqzI491yiZb {
  flex-direction: column;
}
.shyzx2M0_rqzI491yiZb .hZhmPv0Laxf_5zS358Sc {
  font-size: 10px;
}
.shyzx2M0_rqzI491yiZb #admin-panel input[type=text].Y75RAa3LYylGaArM28TA,
.shyzx2M0_rqzI491yiZb input[type=text].Y75RAa3LYylGaArM28TA {
  width: 100% !important;
  min-width: 0 !important;
  border-top: none;
  border-left: none;
  border-right: none;
  min-height: 0;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0.25rem;
  font-size: 12px;
  height: unset;
}
.shyzx2M0_rqzI491yiZb #admin-panel input[type=text].Y75RAa3LYylGaArM28TA:disabled,
.shyzx2M0_rqzI491yiZb input[type=text].Y75RAa3LYylGaArM28TA:disabled {
  background-color: transparent;
}
.shyzx2M0_rqzI491yiZb .Bkjn4gqPHHndydvRJQMP {
  margin-top: 0.25rem;
}

#admin-panel .modal-body input[type=text].Y75RAa3LYylGaArM28TA {
  width: 100% !important;
  min-width: 0 !important;
  border-top: none;
  border-left: none;
  border-right: none;
  min-height: 0;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0.25rem;
  font-size: 12px;
  height: unset;
}
#admin-panel .modal-body input[type=text].Y75RAa3LYylGaArM28TA:disabled {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/reanalyze/reanalyze-text-input/reanalyze-text-input.module.scss"],"names":[],"mappings":"AACA;EACE,sBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAGE;;EAEE,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AADJ;AAGI;;EACE,6BAAA;AAAN;AAIE;EACE,mBAAA;AAFJ;;AAMA;EAGE,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AALF;AAOE;EACE,6BAAA;AALJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.reanalyze_text_container {\n  flex-direction: column;\n\n  .reanalyze_field_label {\n    font-size: 10px;\n  }\n\n  :global(#admin-panel) input[type=\"text\"].reanalyze_text_input,\n  input[type=\"text\"].reanalyze_text_input {\n    width: 100% !important;\n    min-width: 0 !important;\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    min-height: 0;\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    padding-bottom: 0.25rem;\n    font-size: 12px;\n    height: unset;\n\n    &:disabled {\n      background-color: transparent;\n    }\n  }\n\n  .error_message {\n    margin-top: 0.25rem;\n  }\n}\n\n:global(#admin-panel)\n  :global(.modal-body)\n  input[type=\"text\"].reanalyze_text_input {\n  width: 100% !important;\n  min-width: 0 !important;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  min-height: 0;\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 0.25rem;\n  font-size: 12px;\n  height: unset;\n\n  &:disabled {\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reanalyze_text_container": `shyzx2M0_rqzI491yiZb`,
	"reanalyze_field_label": `hZhmPv0Laxf_5zS358Sc`,
	"reanalyze_text_input": `Y75RAa3LYylGaArM28TA`,
	"error_message": `Bkjn4gqPHHndydvRJQMP`
};
export default ___CSS_LOADER_EXPORT___;
